import { getDocs, collection } from 'firebase/firestore'
import Firebase from './firebase'

export const getGameData = async (partner: string) => {
  const ref = collection(Firebase.getDBApp(), `games/${partner}/items`)
  const docs = await getDocs(ref)
  return docs.docs.map((doc) => ({ ...doc.data() }))
}
